// Thin wrapper around the gateway's payment/subscription routes
// (backend/api-gateway/src/gateway/payment.gateway.controller.ts), which
// proxy to ms-payment. All calls go through the shared gateway axios
// instance so the JWT patient token is attached automatically.
import api from "../../api/axios";
import { PAYMENT_PATHS } from "../../api/endpoints";

export const initiatePayment = ({ userId, userType = "patient", plan, billingCycle }) =>
  api
    .post(PAYMENT_PATHS.INITIATE, { userId, userType, plan, billingCycle })
    .then((res) => res.data);

export const refundPayment = (flouciPaymentId) =>
  api.post(PAYMENT_PATHS.REFUND(flouciPaymentId)).then((res) => res.data);

export const confirmPayment = (flouciPaymentId) =>
  api.post(PAYMENT_PATHS.CONFIRM(flouciPaymentId)).then((res) => res.data);

export const getPaymentHistory = (userId) =>
  api
    .get(PAYMENT_PATHS.HISTORY, { params: { userId } })
    .then((res) => res.data);

export const getCurrentPlan = (userId) =>
  api.get(PAYMENT_PATHS.PLAN(userId)).then((res) => res.data);

export const getSubscription = (userId) =>
  api.get(PAYMENT_PATHS.SUBSCRIPTION(userId)).then((res) => res.data);

export const cancelSubscription = (userId) =>
  api
    .delete(PAYMENT_PATHS.CANCEL_SUBSCRIPTION, { params: { userId } })
    .then((res) => res.data);
